<app-common-modal-wrapper
  icon="ic-verification-20"
  saveBtnText="Proceed with Verification"
  [header]="config.header"
  [isLoading]="isLoading()"
  [isDisabled]="selectedContacts.length == 0"
  (close)="close()"
  (submitModal)="confirm()"
>
  <div class="actions">
    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-8"
      [disabled]="isLoading()"
      (click)="onAddContact()"
    >
      <i class="icon ic-add-20"></i>
      <span>Add Contact</span>
    </button>
  </div>

  <div>
    @if (isLoading()) {
      <app-loader/>
    } @else {
      @if (individualDto?.contacts?.length) {
        <app-disclaimer
          icon="ic-info-circle-20"
          color="light-gray"
        >{{ config.message }}
        </app-disclaimer>

        <app-list-grid-client-side
          rowSelection="single"
          [colDefs]="colDefs"
          [rowData]="viewContacts()"
          [isFullWidthRow]="isFullWidthRow"
          [fullWidthCellRenderer]="fullWidthCellRenderer"
          [getRowHeight]="getRowHeight"
          [gridOptions]="gridOptions"
          [pagination]="false"
          (select)="onSelectContacts($event)"
          (gridReady)="onGridReady($event)"
        />
      } @else {
        <div class="d-flex flex-column align-items-center justify-content-center">
          <h3 class="font-size-16 font-weight-600 color-gray-700">No Contacts</h3>

          <div class="color-gray-700 font-weight-normal mb-3">
            We can’t find any of your contact. Please add one to proceed with Verification
          </div>

          <button
            type="button"
            class="btn btn-primary d-flex align-items-center gap-8"
            [disabled]="isLoading()"
            (click)="onAddContact()"
          >
            <i class="icon ic-add-20"></i>
            <span>Add Contact</span>
          </button>
        </div>
      }
    }
  </div>

</app-common-modal-wrapper>
